export default __webpack_public_path__ + "static/media/skippedmeal_1@2x.ee58ae70.jpg";